import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  errorStr: string;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    errorStr: ""
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorStr: error.toString() };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error boundary:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div className="w-full flex items-center justify-center p-8 bg-ows-charcoal/5 rounded-xl border border-ows-dark/10 min-h-[300px]">
          <div className="max-w-md text-center flex flex-col items-center">
            <h2 className="text-ows-dark mb-4 font-display font-light tracking-widest uppercase">System Disruption</h2>
            <p className="text-ows-dark/60 mb-6 text-sm">
              We encountered an unexpected anomaly while rendering this component.
            </p>
            <div className="text-xs bg-black/90 text-ows-orange p-4 rounded-md mb-8 max-w-full overflow-x-auto text-left font-mono border border-ows-orange/30">
              {this.state.errorStr}
            </div>
            <button
              className="px-6 py-2 bg-ows-teal text-white text-[10px] font-bold tracking-widest uppercase rounded-lg hover:bg-ows-dark transition-all"
              onClick={() => {
                this.setState({ hasError: false });
              }}
            >
              Reinitialize
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
